import { render, staticRenderFns } from "./news_video_details.vue?vue&type=template&id=4c25e442&scoped=true&"
import script from "./news_video_details.vue?vue&type=script&lang=js&"
export * from "./news_video_details.vue?vue&type=script&lang=js&"
import style0 from "./news_video_details.vue?vue&type=style&index=0&id=4c25e442&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25e442",
  null
  
)

export default component.exports